export class CustomAmountDistributionDto {
  lesseeAmount?: number;
  lessorAmount?: number;
}

export class FinishDebateRequestDto {
  customRentalPaymentDistribution?: CustomAmountDistributionDto;
  customDepositDistribution?: CustomAmountDistributionDto;
  customInsuranceCompensation?: CustomAmountDistributionDto;
  lessorDebt?: number;
  rentLessorPayoutFromDeposit?: number;
  lesseeResponsibility?: boolean;
  lesseeDebt?: number;
  isReturnImpossible?: boolean;
  decision: string;
  decisionNotes?: string;
}

export type Group = {
  id: number;
  description: string;
  languageCode: string;
  name: string;
};

export type Category = {
  id: number;
  name: string;
  description: string;
  parent_id: null | number;
  root_parent_id: null | number;
  order: number;
  languageCode: string;
  children: Category[];
  productCategories: Group[];
};

export type CardType = {
  id: string;
  userId: string;
  number: string;
  cvc: string;
  cardLast4: string;
  expireDate: string;
  strExpireDate: string;
  cardHolder: string;
};

export type WalletType = {
  id: string;
  userId: string;
  address: string;
  ballance: number;
  lastSyncDate?: number;
  active: boolean;
  restoreInfo: [
    {
      key: string;
      value: string;
    },
    {
      key: string;
      value: string;
    },
  ];
};

export type PutposeType = "PAYMENT" | "PAYOUT";
export type ExistPaymentMethods = {
  id: string;
  userId: string;
  cardId?: string;
  walletId?: string;
  methodType: string;
  purpose: PutposeType;
};
export type PaymentMethodsType = {
  card?: CardType;
  wallet: WalletType | null;
  paymentMethods: ExistPaymentMethods[];
};

export type DebateStatuses = "WAIT" | "IN_PROGRESS" | "COMPLETED" | "CANCELLED";

type DebateUserDetails = {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  patronymic?: string;
  avatar?: string;
  description?: string;
  lastSyncDate?: string;
  lastSyncBalance?: string;
  walletConnected: boolean;
  rating?: number;
  reviewCount: number;
  cityId: number;
  ibanLast4?: string;
};

type DebateProductDetailsType = {
  id: string;
  productGroupId: number;
  userId: string;
  status: string;
  name: string;
  video?: string;
  description: string;
  originalPhotos: string[];
  previewPhotos: string[];
  price: number;
  rentalDay: number;
  rentalWeek: number;
  rentalMonth: number;
  unavailableWeekdays: string[];
  unavailableDates: string[];
  activeComment?: string;
  activeCommentRead: boolean;
  rating?: number;
  reviewCount: number;
  createdAt: string;
  updatedAt: string;
  moderatedAt: string;
};

type DebateChatDetailsType = {
  id: string;
  type: string;
  productId: string;
  createdAt: string;
  updatedAt: string;
};

type DebateParticipantDetailsType = { id: number; type: string; clientId?: string; admin?: string; chatId: string };
export type ProductPhoto = {
  original: string;
  path: string;
  preview: string;
};

export type StatusesOfRentsType =
  | "PENDING_APPROVAL"
  | "ACCEPTED"
  | "BOOKED"
  | "CANCELLED"
  | "STARTED"
  | "DEBATE"
  | "COMPLETED"
  | "WAITING_FOR_LESSOR_ACCEPT"
  | "WAITING_FOR_LESSEE_ACCEPT"
  | "PRODUCT_RETURNED";

export type RentPaymentTyp = "PERCENTAGE" | "DEPOSIT";
type DebateRentDetailsType = {
  id: string;
  status: StatusesOfRentsType;
  insuranceType: RentPaymentTyp;
  totalPrice: string;
  insuranceDeposit: string;
  insurancePercentValue: string;
  insuranceValue: string;
  rentPrice: string;
  deliveryPrice: string;
  dateStart: string;
  dateEnd: string;
  createdAt: string;
  returnTransferDate: string;
  returnEnable: boolean;
  cronNotifies: any[];
  lessor: DebateUserDetails;
  lessee: DebateUserDetails;
  product: DebateProductDetailsType;
  chat: DebateChatDetailsType;
  transferStartDate: string;
  returnWithDispute: boolean;
};
export type ReturnDisputeType = "ENABLE_RETURN" | "RETURN_IMPOSSIBLE" | "DISABLE_RETURN";

export type DebateProcessingActionType = {
  lessorRestriction: boolean;
  lesseeRestriction: boolean;
  returnTransferDate?: string;
  transferStartDate?: string;
  stopProduct: boolean;
  return: ReturnDisputeType;
  returnWithDispute?: boolean;
};

export type CheckReturnTransferDateRequestDto = {
  returnTransferDate: string;
};

export type CancelRentType = {
  id: string;
  status: string;
  dateStart: string;
  returnTransferDate: string;
  productId: string;
  lessorId: string;
  lesseeId: string;
};

export type CheckReturnTransferDateResponse = {
  debateId: string;
  rentId: string;
  returnTransferDate: string;
  willCancelRents: boolean;
  cancelRentsCount: number;
  cancelRents: CancelRentType[];
};

export type AmountDebts = {
  lesseeAmount: number;
  lessorAmount: number;
};
export type DebateSaveAction = {
  // customRentalPaymentDistribution: AmountDebts;
  // customDepositDistribution: AmountDebts;
  customInsuranceCompensation: CustomAmountDistributionDto;
  lesseeResponsibility: boolean;
  lesseeDebt: number;
  lessorDebt: number;
  decision: string;
  decisionNotes: string;
  rentLessorPayoutFromDeposit?: number;
} & DebateProcessingActionType;

export type DebateDetailsType = {
  id: string;
  status: DebateStatuses;
  initiator: string;
  arbitr: string;
  rentId: string;
  decision?: any;
  result?: any;
  confirmedAt?: string;
  system_transfer_initiation: boolean;
  system_return_initiation: boolean;
  saveState?: DebateSaveAction;
  createdAt: string;
  updatedAt: string;
  resolvedAt?: string;
  report?: string;
  rent: DebateRentDetailsType;
  lessee: DebateUserDetails;
  lessor: DebateUserDetails;
  chat: DebateChatDetailsType & {
    participants: DebateParticipantDetailsType[];
  };
  product: DebateProductDetailsType & {
    productAddress: {
      id: number;
      productId: string;
      address: string;
      cityId: number;
    };
    reviews: any[];
    user: {
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      avatar?: string;
      SupportChat: {
        id: string;
      };
      lessorSupportChatId: string;
    };
    isFavorite: boolean;
    isViewed: boolean;
    lessorSupportChatId: string;
    address: {
      location: string;
      address: string;
      formattedData: string;
      cityId: number;
      cityAddress: string;
      latitude: number;
      longitude: number;
    };
    photos: ProductPhoto[];
    productOption: any[];
    productGroup: {
      translations: any[];
      id: number;
    };
    dateRangeUnavailableDates: {
      from: string;
      to: string;
    }[];
  };
};

export type SessionType = {
  id: string;
  status: string;
  createdAt: string;
  takenAt: string;
  closedAt: string;
  takenByAdmin: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  closedByAdmin: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  messageCount: 0;
  lastMessage: {
    authorType: string;
    content: string;
    contentType: string;
    createdAt: string;
    id: number;
    messageType: string;
  };
  availableActions: string[];
  isLast: true;
};
export type GetChatHistoryType = {
  cursor?: number;
  limit?: number;
  localCountry: string;
  chatId: string;
  sessionId?: string;
};

export enum ProductStatusEnum {
  DRAFT = "Draft",
  PENDING = "Pending",
  PUBLISHED = "Published",
  CORRECTIONS = "Corrections",
  ARCHIVE = "Archived",
  STOP = "Stopped",
  DELETED = "DELETED",
}

export enum TransactionPorpouseV2 {
  USER_TO_SERVICE = "USER_TO_SERVICE", // арендаторы → сервис (оплата аренды) (идёт в X) в токенах или фиате
  USER_TO_SERVICE_DEBT = "USER_TO_SERVICE_DEBT", // клиенты → сервис (оплата долгов) (идёт в X) в токенах или фиате
  SERVICE_TO_LESSOR = "SERVICE_TO_LESSOR", // сервис → арендодатель (выплата аренды) (идёт в Y)
  FREEZE_AMOUNT = "FREEZE_AMOUNT", // заморозка на кошельке пользователя (не X/Y)
  UNFREEZE_AMOUNT = "UNFREEZE_AMOUNT", // разморозка (не X/Y)
  TOKEN_BURN = "TOKEN_BURN", // сжигание на кошельке пользователя (идёт в B)
  SERVICE_TO_USER_REFUND_RENTAL = "SERVICE_TO_USER_REFUND_RENTAL", // сервис → арендатор (возврат арендной платы при отмене) (уменьшает X)
  SERVICE_TO_USER_REFUND_INSURANCE = "SERVICE_TO_USER_REFUND_INSURANCE", // только банк, сервис → арендатор/арендодатель (возврат страховки при отмене) (не влияет на X/Y)
  COUNTRY_TO_INSURANCE_TRANSFER = "COUNTRY_TO_INSURANCE_TRANSFER", // банк страны → банк страховой (фиатный перевод страховых средств)
  INSURANCE_TO_COUNTRY_TRANSFER = "INSURANCE_TO_COUNTRY_TRANSFER", // банк страховой → банк страны (обратный перевод при отмене аренды)
  SERVICE_DEBT_REPAYMENT = "SERVICE_DEBT_REPAYMENT", // удержание сервисом суммы из выплаты арендодателю в счёт долга (уменьшает долг)
  CARD_BINDING = "CARD_BINDING", // привязка карты через Revolut ордер $1 (не влияет на X/Y)
}
